import { FieldmagicRelateOption } from '../../../services/relate-search.service';
import { FieldmagicDataGridPersistedData } from '../../../shared/components/data-grid/data-grid.component';
import { blank, Identifiable, Omit, OptionalValue } from '../../../shared/utils/common';

export type ProjectMilestone = Identifiable & {
  name: string;
  tasks: ProjectTask[];
  record_order?: number;
}

export type ProjectTask = Identifiable & {
  name: string;
  estimated_duration?: number;
  budget_hourly_rate?: number;
  estimated_labour_cost?: number;
  estimated_material_cost?: number;
  estimated_equipment_cost?: number;
  estimated_other_cost?: number;
  estimated_revenue?: number;
  description?: string;
  record_order?: number;
  role?: Identifiable & {
    text: string;
  };
  department?: FieldmagicRelateOption;

  estimated_labours?: ProjectTaskLabour[];
  estimated_materials?: ProjectTaskCataloguedMaterial[];
  estimated_equipments?: ProjectTaskEquipment[];
  estimated_other_items?: ProjectTaskOtherItem[];
};

export type ProjectTemplate = Identifiable & {
  project_name: string;
  milestones: ProjectMilestone[];
};

export type ProjectTaskLabour = Identifiable & FieldmagicDataGridPersistedData & {
  item?: OptionalValue<FieldmagicRelateOption>;
  hourly_rate?: number;
  unit_price?: number;
  duration?: number;
  revenue?: number;
  markup?: number;
};

export type ProjectTaskCataloguedMaterial = Identifiable & FieldmagicDataGridPersistedData &  {
  item: FieldmagicRelateOption;
  unit_cost?: number;
  unit_price?: number;
  quantity?: number;
  revenue?: number;
  markup?: number;
};

export type ProjectTaskEquipment = Identifiable & FieldmagicDataGridPersistedData & {
  item: FieldmagicRelateOption;
  unit_cost?: number;
  unit_price?: number;
  quantity?: number;
  revenue?: number;
  markup?: number;
};

export type ProjectTaskOtherItem = Omit<ProjectTaskCataloguedMaterial, 'item'> & {
  description: string;
};

export type DisplayedCategorizedTaskCost = {
  __category?: 'labour' | 'material' | 'equipment' | 'other';
};

const _COST_CATEGORY_PRIORITIZATION = {
  labour: 0,
  material: 1,
  equipment: 2,
  other: 3,
};

export const sort_costings = <T extends DisplayedCategorizedTaskCost>(costings: T[]): T[] => {
  if (blank(costings)) {
    return [];
  }

  return [
    ... costings.sort((a, b) => _COST_CATEGORY_PRIORITIZATION[a.__category] - _COST_CATEGORY_PRIORITIZATION[b.__category]),
  ];
};